module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path d=\"M160 48v224h64v192l128-256h-64l64-160H160z\"></path></svg>"